import {
  FormHandler,
  FormItem,
  MenuPresets,
  RelationEditor,
} from '@framework/form';
import { Drawer } from '@framework/ui';
import { Button, ButtonProps, Collapse, message } from 'antd';
import React from 'react';
import { BooleanConditionEditorInput } from '../../../../../../inputs/expressions-editor/conditions/BooleanConditionEditorInput';
import { StaticBooleanConditionSchema } from '../../../../../../inputs/expressions-editor/conditions/BooleanConditionSchema';
import { RichTextAdvancedInput } from '../../../../../../inputs/rich-text-advanced/RichTextAdvancedInput';
import { DrawerEditorButtonRow } from '../../../../../../ui/drawer';
import { StyledDrawerCollapse } from '../../../../../../ui/drawer/StyledDrawerCollapse';
import { IWidgetOption } from '../../../../Widget';
import { widgetOptionDividerValidator } from './util/widgetOptionValidator';
const { Panel } = Collapse;

export interface IWidgetOptionDividerEditDrawerProps {
  editor: RelationEditor<IWidgetOption>;
  buttonProps?: Omit<ButtonProps, 'onClick'>;
}

export function WidgetOptionDividerEditDrawer(
  props: IWidgetOptionDividerEditDrawerProps,
) {
  const { editor, buttonProps } = props;

  return (
    <>
      <Button
        children="+ Divisore"
        {...buttonProps}
        onClick={() => {
          editor.handle.open({
            type: 'divider',
            label: [{ type: 'text', text: '' }],
            visible: StaticBooleanConditionSchema.cast({}, { assert: false }),
          });
        }}
      />
      <Drawer
        maskClosable={false}
        title="Configurazione divisore"
        size="large"
        placement="right"
        onClose={editor.handle.cancel}
        open={
          editor.handle.isVisible && editor.handle.current?.type === 'divider'
        }
      >
        <FormHandler
          layout="vertical"
          schema={widgetOptionDividerValidator}
          initialValues={
            editor.handle.current ??
            widgetOptionDividerValidator.cast({}, { assert: false })
          }
          // validate={schemaToValidator(createAccessTokenValidator)}
          onSubmit={async rawValues => {
            try {
              const values = await widgetOptionDividerValidator.validate(
                rawValues,
              );
              const type = editor.handle.apply(values);
              if (type === 'updated') {
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                message.success('Divisore modificato');
              } else {
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                message.success('Divisore aggiunto');
              }
            } catch (e) {
              // eslint-disable-next-line @typescript-eslint/no-floating-promises
              message.error('Si è verificato un errore nella gestione del divisore'); // prettier-ignore
              console.error(e);
            }
          }}
        >
          <FormItem name="label" label="Etichetta">
            <RichTextAdvancedInput
              rows={4}
              name="label"
              menus={MenuPresets.Inline}
            />
          </FormItem>

          {/* TODO Regole di validazione/visibilità */}
          <StyledDrawerCollapse defaultActiveKey={['view']} ghost>
            <Panel header="Regole di Visualizzazione" key="view">
              <FormItem name="visible" label="Visibilità">
                <BooleanConditionEditorInput name="visible" label="Visibile" />
              </FormItem>
            </Panel>
          </StyledDrawerCollapse>

          <DrawerEditorButtonRow editor={editor} />
        </FormHandler>
      </Drawer>
    </>
  );
}
